import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/background-jobs")({
	component: () => <Outlet />,
});
